import React, { useMemo } from 'react';
import { Tabs } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import VehicleFuelEntryForm from './VehicleFuelEntryForm';
import VehicleFuelHistory from './VehicleFuelHistory';
import FuelOverview from './FuelOverview';
import FuelPumpList from './FuelPumpList';
import FuelTransferList from './FuelTransferList';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Button from '../../../components/common/Button';

const VehicleFuelMain: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const activeKey = useMemo(() => {
    if (location.pathname.endsWith('/overview')) return 'overview';
    if (location.pathname.endsWith('/history')) return 'history';
    if (location.pathname.endsWith('/pumps')) return 'pumps';
    if (location.pathname.endsWith('/transfers')) return 'transfers';
    return 'entry';
  }, [location.pathname]);

  return (
    <Tabs
      activeKey={activeKey}
      onChange={(key) => navigate(`/machinery/fuel/${key === 'entry' ? 'entry' : key}`)}
      tabBarExtraContent={
        <Button
          action="add"
          icon={<UploadOutlined />}
          onClick={() => navigate('/machinery/fuel/import')}
        >
          {t('machinery.fuel.common.import')}
        </Button>
      }
      items={[
        { key: 'overview', label: t('machinery.fuel.common.overviewTab'), children: <FuelOverview /> },
        { key: 'entry', label: t('machinery.fuel.common.entryTab'), children: <VehicleFuelEntryForm /> },
        { key: 'history', label: t('machinery.fuel.common.historyTab'), children: <VehicleFuelHistory /> },
        { key: 'pumps', label: t('machinery.fuel.common.pumpsTab'), children: <FuelPumpList /> },
        { key: 'transfers', label: t('machinery.fuel.common.transfersTab'), children: <FuelTransferList /> },
      ]}
    />
  );
};

export default VehicleFuelMain; 